module.exports = __webpack_public_path__ + "cb57a538ad01ec9f9c909630f272eddb.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.woff?t=1505201933224
// module id = 192
// module chunks = 1